import axios from './http'

export default {
    searchCustomer(params){
        return axios.get('/mst_customer', {
            params: {
                "area_code": params.customerArea,
                // "bptype_code" : params.customerType,
                "lob_code": params.customerType,
                "pricetype_code" : params.priceType,
                "keyword": params.keyword
            }
        })
        .then(function (response) {
            return Promise.resolve(response);
        })
        .catch(function (error) {
            return Promise.reject(error);
        });
    },
    search(keyword){
        return axios.get('/customer/search', {
            params: {
                "keyword": keyword
            }
        })
        .then(function (response) {
            return Promise.resolve(response);
        })
        .catch(function (error) {
            return Promise.reject(error);
        });
    },
    getLobType(){
        return axios.get('/customer/lobtype')
        .then(function (response) {
            // console.log(response)
            return Promise.resolve(response)
        })
        .catch(function (error) {
            return Promise.reject(error)
        });
    },
    getLob(){
        return axios.get('/customer/lob')
        .then(function (response) {
            // console.log(response)
            return Promise.resolve(response)
        })
        .catch(function (error) {
            return Promise.reject(error)
        });
    },
    checkCustomersImport(customers){
        var formData = {
            customers: customers
        }

        return axios.post('/customer/check-customer-import', formData)
        .then(function (response) {
            return Promise.resolve(response);
        })
        .catch(function (error) {
            return Promise.reject(error);
        });
    }
}